import React from "react";
import { Form } from "@redriver/cinnamon";
import { ServiceTypesRadioGroup } from "../lookups";
import QuarterlyServiceTermsForm from "./QuarterlyServiceTermsFrom";
import {FormattedNumericInput} from "../../../components/forms";
import { Icon } from "semantic-ui-react";

const ServiceForm = ({ formProps, contractTypeResponse, onChangeUpload }) => (
    <Form {...formProps} className="service-form">
        <Form.Input
            fluid
            required
            field="name"
            label="Name"
            className="highlighted-input"
            placeholder="Name..."
        />
        <Form.Group className="group">
            <ServiceTypesRadioGroup
                field="type"
                label="Service Type"
                fluid
                required
            />
            <FormattedNumericInput
                field="defaultValue"
                label="Default Value"
                decimalPlaces={2}
                width={10}
                subLabel={process.env.MAJOR_CURRENCY}
                subLabelPosition="left"
            />
        </Form.Group>
            <Form.Group widths="equal">
                <Form.Checkbox
                    field="multiplyByDeviceNumber"
                    label="Multiply by Device Number"
                />
                <Form.Checkbox
                    field="softwareSupportRequired"
                    label="Software Support Required"
                />
            </Form.Group>
            <Form.Input
                fluid
                field="description"
                label="Description"
                className="highlighted-input"
                placeholder="Description..."
            />
            <Form.Input
                fluid
                field="termsAndConditionsReference"
                label="Terms and Conditions Reference"
                className="highlighted-input"
                placeholder="Terms and Conditions Reference..."
            />
            <Form.Group widths="equal">
                <Form.Input
                    fluid
                    field="ipsBillingCode"
                    label="Billing Code"
                    className="highlighted-input"
                    placeholder="Billing Code..."
                />
                <Form.Input
                    fluid
                    field="ipsSku"
                    label="SKU"
                    className="highlighted-input"
                    placeholder="SKU..."
                />
            </Form.Group>
            <Form.Group widths="equal">
                <Form.Checkbox
                    field="requiredOnEquipmentSchedule"
                    label="Required on Product Schedule"
                />
                <Form.Checkbox
                    field="hideFromCustomerView"
                    label="Hide From Customer View"
                />
            </Form.Group>
            <Form.CheckboxGroup
                field="contractType"
                label="Contract Type(s)"
                options={contractTypeResponse != null ? contractTypeResponse : []}
            />
            <Form.Group widths="equal">
                <div className="greyed-field">
                    <FormattedNumericInput
                        fluid
                        field="settlementDiscountPercentage"
                        label="Settlement Discount %"
                        className="highlighted-input"
                        placeholder="Settlement Discount %..."
                    />
                </div>
                <Form.Input
                    fluid
                    field="vatCode"
                    label="VAT Code"
                    className="highlighted-input"
                    placeholder="VAT Code..."
                />
            </Form.Group>
            <Form.Group widths="equal">
                <Form.Input
                    fluid
                    field="excessInvoiceNominalCode"
                    label="Excess Invoice Nominal Code"
                    className="highlighted-input"
                    placeholder="Excess Invoice Nominal Code..."
                />
                <Form.Input
                    fluid
                    field="minimumInvoiceNominalCode"
                    label="Minimum Invoice Nominal Code"
                    className="highlighted-input"
                    placeholder="Minimum Invoice Nominal Code..."
                />
                <Form.Input
                    fluid
                    field="code"
                    label="Code"
                    className="highlighted-input"
                    placeholder="Code..."
                    maxLength={8}
                    required
                />
            </Form.Group>
            {process.env.TRADE_AS_IPS && (
                <Form.Group>
                    <div style={{marginTop: 10}}>
                        <QuarterlyServiceTermsForm
                            {...formProps}
                            onChangeUpload={onChangeUpload}
                            editMode={true}
                        />
                        {formProps.value?.existingTerms && (
                            <div
                                style={{
                                    width: "350px",
                                    display: "flex",
                                    flexDirection: "row",
                                    alignItems: "center",
                                }}
                            >
                                <Icon name="warning sign" color="yellow"/>
                                <p>There are existing terms for this service.</p>
                            </div>
                        )}
                    </div>
                </Form.Group>
            )}
    </Form>
);

export default ServiceForm;
